<template>
  <section class="pitch-type-attributes">
    <super-facilities
      :super-facilities="campsiteSuperFacilities"
      :capacity-display="pitchtype.capacityDisplay"
      :facilities="pitchtype.facilities"
      :restrictions="pitchtype.restrictions"
      :is-byo="pitchtype.isByo"
      :bedrooms="pitchtype.bedrooms"
      :pitchtype-rating="pitchtype.rating"
      :pitchtype-ratecount="pitchtype.rateCount"
    />

    <translate
      v-if="pitchtype.groundType"
      tag="p"
      class="ground"
      :tt="{
        pitchTypeGroundType: pitchtype.groundType,
      }"
    >
      Ground type: {pitchTypeGroundType}
    </translate>

    <pitch-type-dimensions :pitch-type="pitchtype" />
  </section>
</template>

<script lang="ts">
import type {
  CampsiteFacility,
  PitchType,
} from '../../../../campsite-details/types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class PitchTypeAttributes extends Vue {
  @Prop()
  campsiteSuperFacilities: CampsiteFacility[]

  @Prop()
  pitchtype: PitchType
}

export default toNative(PitchTypeAttributes)
</script>
<style scoped>
/* desktop only */
.pitch-type-attributes {
  width: 100%;
  margin-right: 2em;
}

.pitch-type-attributes :deep(.facilities) {
  justify-content: flex-start;
  padding: 0;
  column-gap: 2em;
  row-gap: 0.5em;
  font-size: inherit;
  margin-bottom: 0.75em;
}

.pitch-type-attributes :deep(.facility),
.size {
  margin: 0;
}

.ground {
  margin: 0 0 0.75em 0;
}

.rooms {
  display: flex;
  gap: 0.5em;
  align-items: center;
}

.rooms :deep(h4),
.rooms :deep(p) {
  margin: 0;
}
</style>
